module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mult-select associated"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title + '选择',
      "visible": _vm.dialogVisible,
      "modal": _vm.modal
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.templateList.length > 1) ? _c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "template-box"
  }, [_vm._l((_vm.templateList), function(template, index) {
    return [(_vm.templateList.length < 4 ? true : index < 2) ? _c('div', {
      key: template.key,
      staticClass: "template-item",
      class: {
        'active': template.key === _vm.curTemplate.key
      },
      on: {
        "click": function($event) {
          _vm.toggleTemplate(template, 'click')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(template.value))])]) : (index === 3) ? _c('el-dropdown', {
      key: template.key,
      on: {
        "command": _vm.toggleTemplate
      }
    }, [_c('div', {
      staticClass: "template-item",
      class: {
        'active': _vm.foldTemplate.key === _vm.curTemplate.key
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.foldTemplate.value))]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-caret-bottom el-icon--right"
    })]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, _vm._l((_vm.foldTemplateList), function(template) {
      return _c('el-dropdown-item', {
        key: template.key,
        attrs: {
          "command": template
        }
      }, [_vm._v(_vm._s(template.value) + "\n                ")])
    }))], 1) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-left"
  }, [(_vm.groups.length) ? _c('el-select', {
    staticClass: "manager",
    attrs: {
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.getUserList('group')
      }
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }, _vm._l((_vm.groups), function(option) {
    return _c('el-option', {
      key: option.key,
      attrs: {
        "label": option.value,
        "value": option.key
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "size": "small",
      "prefix-icon": "el-icon-search",
      "placeholder": _vm.placeholderStr
    },
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.contactSearch),
      callback: function($$v) {
        _vm.contactSearch = $$v
      },
      expression: "contactSearch"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v(_vm._s('新建' + _vm.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "table",
    attrs: {
      "data": _vm.userList,
      "max-height": "370",
      "row-key": "id",
      "border": ""
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _vm._l((_vm.headerArray), function(header) {
    return _c('el-table-column', {
      key: header.attr,
      attrs: {
        "prop": header.attr,
        "label": header.attrName
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [(_vm.multiselect) ? _c('div', {
    staticClass: "select-length"
  }, [_vm._v("已选 " + _vm._s(_vm.idArr.length) + " 个")]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-850bcd18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/associated-new.vue
// module id = 1314
// module chunks = 82